import { useRouter } from 'next/router'

import HelpCenterArticlesFeature from 'app/features/HelpCenter/HelpCenterArticlesFeature'
import { useGetCategoriesData } from 'app/features/HelpCenter/hooks/useGetCategoriesData'
import { isOfType } from 'app/utils/helpers/type.helpers'

import NextSeo from '~/containers/NextSeo'

import BreadcrumbsBlock from './components/BreadcrumbsBlock'
import HelpCenterContainer from './components/HelpCenterContainer'

const HelpCenterSubcategoryView = () => {
  const { query, isFallback } = useRouter()

  const { category } = query ?? {}
  const categorySlug = isOfType.string(category) ? category : ''

  const { categoryName, subcategoryName } = useGetCategoriesData({
    categorySlug
  })
  const currentCategoryName = subcategoryName || categoryName || ''
  const title = `${currentCategoryName} Help Centre`

  return (
    <>
      <NextSeo
        title={title}
        description={title}
        openGraph={{ title: title, description: title }}
        {...(!currentCategoryName && { canonical: '404' })}
      />

      <BreadcrumbsBlock categorySlug={categorySlug} isLoading={isFallback} />

      <HelpCenterContainer categorySlug={categorySlug} isLoading={isFallback}>
        <HelpCenterArticlesFeature
          categorySlug={categorySlug}
          isLoading={isFallback}
        />
      </HelpCenterContainer>
    </>
  )
}

export default HelpCenterSubcategoryView
